<template>
  <div class="share-container">
    <van-nav-bar :title="$t('share')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
      <template #right>
        <div v-clipboard:copy="userInfo.address"
          v-clipboard:success="onCopy" class="user-address">
          <img src="../../assets/copy.svg" alt="" />
          <div class="address">{{ userInfo.address }}</div>
        </div>
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="share-box">
        <div class="share-code">
          <div class="qrcode" ref="qrCodeUrl"></div>
        </div>
        <div class="link-bar">
          <div class="text">{{ shareUrl }}</div>
        </div>
        <div
          class="share-btn"
          v-clipboard:copy="shareUrl"
          v-clipboard:success="onCopy"
        >
          {{ $t("share_link") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      shareUrl: "",
      userInfo: "",
    };
  },
  created() {
    console.log(window.location);
    this.shareUrl =
      window.location.origin +
      "/host/" +
      JSON.parse(localStorage.getItem("userInfo")).invite;
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    setTimeout(() => {
      this.createQrCode();
    }, 300);
  },
  methods: {
    onCopy() {
      this.$Toast(this.$t("copySuccess"));
    },
    navBack() {
      this.$router.replace('/');
    },
    createQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.shareUrl,
        width: 175,
        height: 175,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    onCopy() {
      this.$Toast(this.$t("copySuccess"));
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 30px;
  height: 15px;
}
.user-address {
  display: flex;
  align-items: center;
  padding: 0px 10px;
  background: #f4f4f4;
  border-radius: 20px;
  font-size: 14px;
  width: 80px;
  img {
    width: 20px;
    height: 20px;
  }
  .address {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.share-container {
  .content {
    height: calc(100vh - 46px);
    background: url("../../assets/share_bg.jpg") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .share-box {
      width: 90%;
      padding: 60px 15px 40px;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 20px;
      box-sizing: border-box;
      .share-code {
        padding: 3px;
        border: 1px solid #0062f8;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 175px;
          height: 175px;
        }
      }
      .link-bar {
        background: linear-gradient(180deg, #dfe9fb, #fcf4e4);
        font-size: 14px;
        width: 100%;
        padding: 15px 10px;
        border-radius: 5px;
        box-sizing: border-box;
        margin-top: 40px;
      }
      .share-btn {
        text-align: center;
        width: 100%;
        padding: 15px 0;
        color: #fff;
        margin-top: 30px;
        border-radius: 5px;
        background: #0062f8;
        font-size: 14px;
      }
    }
  }
}
@media (min-width: 640px) {
  /deep/ .van-nav-bar--fixed {
    width: 540px;
    left: unset;
  }
  /deep/ .van-nav-bar__content {
    height: 55px;
  }
  .back {
    width: 30px;
    height: 15px;
  }
  .user-address {
    display: flex;
    align-items: center;
    padding: 0px 10px;
    background: #f4f4f4;
    border-radius: 20px;
    font-size: 14px;
    width: 80px;
    img {
      width: 20px;
      height: 20px;
    }
    .address {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .share-container {
    .content {
      height: calc(100vh - 46px);
      background: url("../../assets/share_bg.jpg") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .share-box {
        width: 90%;
        padding: 60px 15px 40px;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
        box-sizing: border-box;
        .share-code {
          padding: 3px;
          border: 1px solid #0062f8;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 175px;
            height: 175px;
          }
        }
        .link-bar {
          background: linear-gradient(180deg, #dfe9fb, #fcf4e4);
          font-size: 14px;
          width: 100%;
          padding: 15px 10px;
          border-radius: 5px;
          box-sizing: border-box;
          margin-top: 40px;
        }
        .share-btn {
          text-align: center;
          width: 100%;
          padding: 15px 0;
          color: #fff;
          margin-top: 30px;
          border-radius: 5px;
          background: #0062f8;
          font-size: 14px;
        }
      }
    }
  }
}
</style>